const defaultTranslate = (_, value) => value;

export default defaultTranslate;
